import { CopyButton, CopyButtonIcon } from "@aircall/blocks";

import { Section, SectionHeader, SectionTitle } from "@/blocks/Section";

const MOCK_CALL_UUID = "3f29c1a4-7b2e-4d6a-9c8f-1e0d5b6a7c4f";

export function PlaygroundSectionCallUuid() {
  return (
    <Section data-test="call-uuid-section">
      <SectionHeader>
        <SectionTitle>Call UUID</SectionTitle>
      </SectionHeader>
      <CopyButton
        value={MOCK_CALL_UUID}
        variant="ghost"
        size="sm"
        className="-ml-2 gap-1 self-start font-normal text-muted-foreground"
        data-test="copy-to-clipboard-text"
      >
        {MOCK_CALL_UUID}
        <CopyButtonIcon className="size-4" />
      </CopyButton>
    </Section>
  );
}
